export default "__VITE_ASSET__zX8tVVUe__"